<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-27 10:35:53
 * @FilePath: /wemeet-admin-new/src/views/brandProduct/index.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <el-tabs v-model="tabName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.label" :name="item.key">
        <template v-if="item.key == 'product'">
          <vab-query-form>
            <vab-query-form-left-panel :span="12">
              <el-button :icon="Plus" type="primary" @click="addBrand($event)">
                {{ meetingType == 'EXHIBITION' ? '添加展品' : '添加产品' }}
              </el-button>
              <el-button v-if="enterpriseCode" :icon="Plus" type="primary" @click="syncProduct($event)">
                同步机构产品
              </el-button>
              <el-button type="success" @click="importBrand($event)">批量导入</el-button>
              <el-button type="success" @click="importResult($event)">导入结果</el-button>
              <el-button v-if="chooseVal.length > 0" type="success" @click="batchStatus(true)">批量上架</el-button>
              <el-button v-if="chooseVal.length > 0" type="danger" @click="batchStatus(false)">批量下架</el-button>
            </vab-query-form-left-panel>
            <vab-query-form-right-panel :span="12">
              <el-form :inline="true" :model="queryForm" @submit.prevent>
                <el-form-item :label="meetingType == 'EXHIBITION' ? '展品名称' : '产品名称'">
                  <el-input v-model.trim="queryForm.likeExhibitName" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="queryForm.status">
                    <el-option label="全部" :value="'ALL'" />
                    <el-option label="已上架展品" :value="'YES'" />
                    <el-option label="下架展品" :value="'NO'" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
                </el-form-item>
              </el-form>
            </vab-query-form-right-panel>
          </vab-query-form>
          <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column
              :label="meetingType == 'EXHIBITION' ? '展品名称' : '产品名称'"
              prop="exhibitName"
              show-overflow-tooltip
            />
            <el-table-column label="排序值" prop="selfSort" show-overflow-tooltip />
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip />
            <el-table-column label="状态" prop="status" show-overflow-tooltip>
              <template #default="{ row }">
                <el-switch
                  v-model="row.status"
                  active-text="上线"
                  inactive-text="下线"
                  size="large"
                  @change="productStatusChange(row)"
                />
              </template>
            </el-table-column>

            <el-table-column label="创建方式" prop="createType" show-overflow-tooltip>
              <template #default="{ row }">
                <el-tag v-if="row.createType == 'ADD' && row.createBy == 'IMPORT'" type="success">批量导入</el-tag>
                <el-tag v-else-if="row.createType == 'ADD'" type="success">自定义创建</el-tag>
                <el-tag v-else type="success">机构产品同步</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" show-overflow-tooltip width="420">
              <template #default="{ row }">
                <el-button plain type="info" @click="handleEdit(row)">编辑</el-button>
                <el-button plain type="info" @click="handleShare(row)">分享</el-button>
                <el-button plain type="info" @click="handleSort(row)">调整排序</el-button>
                <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
              </template>
            </el-table-column>
            <template #empty>
              <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
              <el-empty class="vab-data-empty" description="暂无数据" />
            </template>
          </el-table>
          <el-pagination
            background
            :current-page="queryForm.pageNum"
            :layout="layout"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </template>

        <template v-if="item.key == 'type'">
          <productType />
        </template>

        <template v-if="item.key == 'attr'">
          <attrType />
        </template>

        <template v-if="item.key == 'industry'">
          <industry />
        </template>
        <!-- <template v-if="item.key == 'activeType'">
          <activeType></activeType>
        </template>
        <template v-if="item.key == 'venuesType'">
          <industry></industry>
        </template>
        <template v-if="item.key == 'venuesScale'">
          <industry></industry>
        </template> -->
      </el-tab-pane>
    </el-tabs>

    <edit-sort ref="editRef" @fetch-data="fetchData" />
    <qrCode-preview ref="previewDialog" :url="previewQrcode" :website="previewWebSite" />
    <syncProduct
      ref="syncProductRef"
      :enterprise-code="enterpriseCode"
      :exhibitor-code="queryForm.exhibitorCode"
      @fetch-data="fetchData"
    />

    <generateWxVue ref="generateWxRef" />

    <upload-file ref="upLoadRef" :exhibitor-code="queryForm.exhibitorCode" @fetch-data="queryData" />

    <upload-result ref="resultRef" :exhibitor-code="queryForm.exhibitorCode" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getBrandProductList, editBrandProductStatus, deleteProduct, batchUpDateExhibiti } from '@/api/brand'
  import { useRoute } from 'vue-router'
  import qrCodePreview from '@/components/qrCodePreview'
  import generateWxVue from '@/components/generateWx/generateWx.vue'
  import productType from './components/productType.vue'
  import attrType from './components/attrType.vue'
  import industry from './components/industry.vue'
  import activeType from './components/activeType.vue'
  export default defineComponent({
    name: 'Brand',
    components: {
      EditSort: defineAsyncComponent(() => import('./components/editSort')),
      syncProduct: defineAsyncComponent(() => import('./components/syncProduct')),
      uploadFile: defineAsyncComponent(() => import('./components/visitorImport')),
      uploadResult: defineAsyncComponent(() => import('./components/uploadResult')),
      qrCodePreview,
      generateWxVue,
      productType,
      attrType,
      industry,
      activeType,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          likeExhibitName: '',
          pageNum: 1,
          pageSize: 10,
          exhibitorCode: route.query.exhibitorCode,
          status: 'ALL',
        },
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        enterpriseCode: '',
        syncProductRef: null,
        generateWxRef: null,
        tabName: 'product',
        meetingType: '',
        tabList: [
          {
            key: 'product',
            label: '展品管理',
          },
          {
            key: 'type',
            label: '类型管理',
          },
          {
            key: 'attr',
            label: '属性管理',
          },
          {
            key: 'industry',
            label: '行业管理',
          },
          // {
          //   key: 'activeType',
          //   label: '活动类型',
          // },
          // {
          //   key: 'venuesType',
          //   label: '人数规模',
          // },
          // {
          //   key: 'venuesScale',
          //   label: '空间面积',
          // },
        ],
        upLoadRef: null,
        resultRef: null,
        chooseVal: [],
        industryType: '',
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandProductEdit',
          query: {
            exhibitorCode: state.queryForm.exhibitorCode,
            id: row.exhibitCode,
            enterpriseCode: state.enterpriseCode,
            industryType: state.industryType,
            meetingCode: state.queryForm.meetingCode,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.exhibitCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            row.delFlag = true
            const { msg } = await deleteProduct({
              exhibitCode: row.exhibitCode,
            })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.exhibitorCode = route.query.exhibitorCode
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.meetingType = route.query.meetingType
        state.enterpriseCode = route.query.enterpriseCode
        state.industryType = route.query.industryType
        state.meetingType = route.query.meetingType
        const { data } = await getBrandProductList(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false

        state.tabList[0].label = state.meetingType == 'EXHIBITION' ? '展品管理' : '产品管理'
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const productStatusChange = async (row) => {
        try {
          let obj = {
            exhibitCode: row.exhibitCode,
            status: row.status,
          }
          await editBrandProductStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }

        fetchData()
      }

      onActivated(() => {
        fetchData()
      })

      const addBrand = () => {
        proxy.$router.push({
          path: '/exhibitionManage/brandProductEdit',
          query: {
            exhibitorCode: state.queryForm.exhibitorCode,
            id: 'new',
            enterpriseCode: state.enterpriseCode,
            industryType: state.industryType,
            meetingCode: state.queryForm.meetingCode,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleProduct = () => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: 'new',
          },
        })
      }
      const syncProduct = () => {
        state.syncProductRef.showEdit()
      }
      /**
       * @description: 修改排序。外侧outside 标识修改的是sort ，inside 修改的是selfSort
       * @param {*} row
       * @return {*}
       */
      const handleSort = (row) => {
        state.editRef.showEdit(row, 'inside')
      }
      const handleShare = (row) => {
        // state.previewWebSite = row.exhibitH5Url
        // state.previewQrcode = row.exhibitQrcode
        // state.previewDialog.handleOpen()
        let qrCodeParams = {
          autoColor: false,
          b: 0,
          env: '',
          g: 0,
          jumpPath: row.exhibitCode,
          jumpType: 'PARAMS',
          logo: row.logo,
          params: `{"exhibit":"${row.exhibitCode}"}`,
          path: 'pages/index/index',
          r: 0,
          scenesType: 'EXHIBIT_QRCODE',
          width: 1280,
        }
        state.generateWxRef.handleOpen(row, qrCodeParams, false, row.exhibitH5Url)
      }

      const importBrand = () => {
        state.upLoadRef.showEdit({
          title: state.meetingType == 'EXHIBITION' ? '批量导入展品' : '批量导入产品',
        })
      }
      const importResult = () => {
        state.resultRef.showEdit()
      }

      const handleSelectionChange = (val) => {
        state.chooseVal = val
      }

      const batchStatus = (status) => {
        console.log(state.chooseVal)
        let params = {
          exhibitCode: state.chooseVal.map((v) => v.exhibitCode),
          status,
        }
        batchUpDateExhibiti(params).then((res) => {
          fetchData()
        })
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        productStatusChange,
        handleConfig,
        Delete,
        Search,
        Plus,
        addBrand,
        handleSort,
        handleShare,
        syncProduct,
        importBrand,
        importResult,
        handleSelectionChange,
        batchStatus,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
